import {
  CHANGE_LOCALE,
  GET_ACCOUNT_REQUEST,
  GET_ACCOUNT_SUCCESS,
  GET_ACCOUNT_ERROR,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  CREATE_USER_SESSION,
  DESTROY_USER_SESSION,
  USER_LOGOUT_REQUEST,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_ERROR,
} from './constants';

// Change Locale
export function changeLocale(locale) {
  return {
    type: CHANGE_LOCALE,
    locale,
  };
}

// Get Account
export function getAccountRequest() {
  return {
    type: GET_ACCOUNT_REQUEST,
  };
}

export function getAccountSuccess(response) {
  return {
    type: GET_ACCOUNT_SUCCESS,
    response,
  };
}

export function getAccountError(error) {
  return {
    type: GET_ACCOUNT_ERROR,
    error,
  };
}

// Get Profile
export function getProfileRequest() {
  return {
    type: GET_PROFILE_REQUEST,
  };
}

export function getProfileSuccess(response) {
  return {
    type: GET_PROFILE_SUCCESS,
    response,
  };
}

export function getProfileError(error) {
  return {
    type: GET_PROFILE_ERROR,
    error,
  };
}

// Update Profile
export function updateProfileRequest(payload) {
  return {
    type: UPDATE_PROFILE_REQUEST,
    payload,
  };
}

export function updateProfileSuccess(response) {
  return {
    type: UPDATE_PROFILE_SUCCESS,
    response,
  };
}

export function updateProfileError(error) {
  return {
    type: UPDATE_PROFILE_ERROR,
    error,
  };
}

// User Session
export function createUserSession(user, token, nextPathname) {
  return {
    type: CREATE_USER_SESSION,
    user,
    token,
    nextPathname,
  };
}

export function destroyUserSession(redirectUrl) {
  return {
    type: DESTROY_USER_SESSION,
    redirectUrl,
  };
}

// User Logout
export function userLogoutRequest() {
  return {
    type: USER_LOGOUT_REQUEST,
  };
}

export function userLogoutSuccess() {
  return {
    type: USER_LOGOUT_SUCCESS,
  };
}

export function userLogoutError(error) {
  return {
    type: USER_LOGOUT_ERROR,
    error,
  };
}
